import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';

function Footer() {
    return (
        <footer>
            <div className="container">

                <div className="row">

                    <div className="col-12 col-lg-3">

                        <h3> Contact Us</h3>

                        <p style={{ marginBottom: "32px" }}>
                            <Link to="/contact">613.520.2600 x3423 <br /><br /> Carleton Immersive Media Studio <br /> Carleton University <br />Visualization and Simulation Building, Fourth Floor<br />1125 Colonel By Drive <br /> Ottawa, ON K1S5B6</Link>
                        </p>


                    </div>

                    <div className="col-4 col-md-3 col-lg-2">

                        <h3> What We Do</h3>
                        <p><Link to="/aboutus">About Us</Link></p>
                        <p><Link to="/team">Our Team</Link></p>
                        <p><Link to="/blogs">Blog</Link></p>
                        <p><Link to="/trainingPrograms">Training</Link></p>
                        <p><Link to="/publications">Publications</Link></p>
                    </div>

                    <div className="col-4 col-md-3 col-lg-2">

                        <h3> Projects</h3>

                        <p>
                            <Link to={{ pathname: '/projects' }} state={{ projectFilter: 'Digitization' }}>
                                Digitization
                            </Link>
                        </p>
                        <p>
                            <Link to={{ pathname: '/projects' }} state={{ projectFilter: 'Modelling' }}>
                                Modelling
                            </Link>
                        </p>
                        <p>
                            <Link to={{ pathname: '/projects' }} state={{ projectFilter: 'Digitally Assisted Fabrication' }}>
                                Fabrication
                            </Link>
                        </p>
                        <p>
                            <Link to={{ pathname: '/projects' }} state={{ projectFilter: 'Digitally Assisted Storytelling' }}>
                                Storytelling
                            </Link>
                        </p>
                    </div>

                    <div className="col-4 col-md-3 col-lg-2">
                        <h3> Follow Us</h3>
                        <a className="footer-social-icon" target="_blank" rel="noopener noreferrer" href="http://instagram.com/thecimslab">
                            <svg aria-hidden="true" focusable="false" width="1em" height="1em" fill="white" viewBox="0 0 64 64"><path d="M58.022 21.275c-.178-2.671-.534-4.63-1.247-6.233-.712-1.78-1.602-3.205-3.027-4.63-1.425-1.425-2.85-2.315-4.63-3.027-1.603-.713-3.562-1.069-6.233-1.247-2.85-.178-3.74-.178-10.685-.178s-7.836 0-10.685.178c-2.671.178-4.63.534-6.233 1.247-1.78.712-3.205 1.602-4.63 3.027-1.425 1.425-2.315 2.85-3.027 4.63-.713 1.603-1.069 3.562-1.247 6.233C6.2 23.946 6.2 24.837 6.2 31.96s0 7.836.178 10.685c.178 2.671.534 4.63 1.247 6.233.712 1.78 1.602 3.205 3.027 4.63 1.425 1.425 2.85 2.315 4.63 3.027 1.603.713 3.562 1.069 6.233 1.247 2.671.178 3.562.178 10.685.178s7.836 0 10.685-.178c2.671-.178 4.63-.534 6.233-1.247 1.78-.712 3.205-1.602 4.63-3.027 1.425-1.425 2.315-2.85 3.027-4.63.713-1.603 1.069-3.562 1.247-6.233.178-2.671.178-3.562.178-10.685s0-7.836-.178-10.685zm-4.63 21.192c-.178 2.493-.534 3.918-.89 4.808-.535 1.247-1.069 2.137-1.96 3.028-.89.89-1.78 1.424-3.027 1.959-.89.356-2.315.712-4.808.89-2.671.178-3.562.178-10.507.178s-7.658 0-10.507-.178c-2.493-.178-3.918-.534-4.808-.89-1.247-.535-2.137-1.069-3.028-1.96-.89-.89-1.424-1.78-1.959-3.027-.356-.89-.712-2.315-.89-4.808-.178-2.671-.178-3.562-.178-10.507s0-7.658.178-10.507c.178-2.493.534-3.918.89-4.808.535-1.247 1.069-2.137 1.96-3.027.89-.89 1.78-1.425 3.027-1.96.89-.356 2.315-.712 4.808-.89 2.85-.178 3.562-.178 10.507-.178s7.657 0 10.507.178c2.493.178 3.918.534 4.808.89 1.247.535 2.137 1.07 3.028 1.96.89.89 1.424 1.78 1.958 3.027.357.89.713 2.315.89 4.808.179 2.671.179 3.562.179 10.507s0 7.658-.178 10.507z"></path><path d="M32.2 18.604c-7.301 0-13.178 5.877-13.178 13.178S24.899 44.96 32.2 44.96c7.301 0 13.178-5.877 13.178-13.178S39.501 18.604 32.2 18.604zm0 21.726c-4.808 0-8.548-3.918-8.548-8.548s3.918-8.548 8.548-8.548 8.548 3.918 8.548 8.548-3.74 8.548-8.548 8.548zM46.09 15.042c-1.603 0-3.027 1.425-3.027 3.027s1.246 3.028 3.027 3.028c1.603 0 3.027-1.247 3.027-3.028s-1.424-3.205-3.027-3.027z"></path></svg>
                        </a>
                    </div>



                </div>

            </div>
        </footer>
    );
}

export default Footer;
